<div class="enhancements" [ngClass]="{'edit': edit,  'fh': settingsManager.settings.fhStyle}">
  @for (slot of slots; track slot + $index; let i = $index) {
  <div class="slot {{slot}}" ghs-pointer-input
    [ngClass]="{'enhance': !enhancements[slotIndex != undefined ? slotIndex : i]}"
    (singleClick)="enhance(slotIndex != undefined ? slotIndex : i,$event)"
    (doubleClick)="removeEnhancement(slotIndex ? slotIndex :  i,$event)"
    [ghs-tooltip]="edit && 'character.abilities.enhancements.hint.enhance' + (enhancements[slotIndex != undefined ? slotIndex : i] ? 'd': (wipSpecialIndex ? '.wipSpecial' : '')) || ''">
    @if (!enhancements[slotIndex != undefined ? slotIndex : i]) {
    <img class="type"
      [src]="gameManager.enhancementsManager.fh && slot != 'any' ? './assets/images/fh/character/abilities/enhancements/' + slot + '.svg' : './assets/images/character/abilities/enhancements/circle.svg'" />
    }
    @if (enhancements[slotIndex != undefined ? slotIndex : i]) {
    <span class="enhancement">
      @if (enhancements[slotIndex != undefined ? slotIndex : i] == 'plus1') {
      <span class="plus1">+1</span>
      }
      @if (enhancements[slotIndex != undefined ? slotIndex : i] == 'hex') {
      <span class="hex">
        <img src="./assets/images/action/hex/target.svg" />
      </span>
      }
      @if (enhancements[slotIndex != undefined ? slotIndex : i] == 'jump') {
      <span class="jump">
        <span class="text-white" [ghs-label]="'%game.actionIcon.jump%'"></span>
      </span>
      }
      @if (Elements.includes(enhancements[slotIndex != undefined ? slotIndex : i])) {
      <span class="element">
        <span [ghs-label]="'%game.element.' + enhancements[slotIndex != undefined ? slotIndex : i] + '%'"></span>
      </span>
      }
      @if (Conditions.includes(enhancements[slotIndex != undefined ? slotIndex : i])) {
      <span class="condition">
        <span [ghs-label]="'%game.conditionIcon.' + enhancements[slotIndex != undefined ? slotIndex : i] + '%'"></span>
      </span>
      }
    </span>
    }
  </div>
  }
</div>